import { network } from 'services/network';

export const uploadXerFileVersions = (params) => {
    const data = new FormData();
    data.append('file', params.file, params.fileName);

    const payload: any = {
        projectId: params.projectId,
        contractId: params.contractId,
        isBaseline: params.isBaseline,
        contractName: params.contractName,
        versionId: params.versionId,
        uploadingUser: params.uploadingUser,
        versions: params.versions,
        language: params.language,
        mppACEnabled: params.isTransformMPP,
        customVersionName: params.customVersionName,
        isIntegrated: params.isIntegrated,
        runCPM: params.runCPM,
    };

    if (params.plf_file) {
        data.append('plf_file', params.plf_file, params.plf_file.name);
    }

    if (params.anotherFile) {
        data.append('plf_file', params.anotherFile, params.anotherFile.name);
    }

    if (params.versionName) {
        payload.versionName = params.versionName;
    }

    if (params.versionDate) {
        payload.versionDate = params.versionDate;
    }

    data.append('request', JSON.stringify(payload));

    return network
        .post('api/bo/uploadXerFileVersions', data, {
            transformRequest: [
                (data, headers) => {
                    if (headers) {
                        headers['Content-Type'] = 'multipart/form-data';
                    }
                    return data;
                },
            ],
        })
        .then(() => {
            return true;
        });
};
